import React, { FC, useState } from 'react'

import { useInMediaRange } from '@smarty-nx/code-utils'
import { Link } from 'react-router-dom'

import DesktopMenu from './desktop-menu'
import MobileMenu from './mobile-menu'
import classes from './NavBar.module.scss'
import { NavBarProps } from './NavBar.types'
import { Icon } from '../../components'
import { SkipLink } from '../skip-link'

// This component is an interim version of the one for family app.
// It replaces the old NavBar component in the dashboard app if "new design"
// is toggled via `window.toggleHorizonsRedesign()`.
export const NavBar: FC<NavBarProps> = ({
  isAuthenticated,
  isAbandonedAccount,
  isActivated,
  isNotInGroup,
  userHasUsage,
  userHasAgreement,
  memberWithNickname,
  marketingUrl,
  communityUrl,
  logoutUser,
}) => {
  const isMobile = useInMediaRange()
  const [isMenuOpen, setMenuOpen] = useState(false)
  const toggleMenu = () => setMenuOpen((state) => !state)
  const closeMenu = () => setMenuOpen(false)

  return (
    <nav className={classes.root} data-testid="navbar-container">
      <SkipLink />
      <div className={classes.inner}>
        {isAuthenticated ? (
          <Link
            to="/dashboard"
            data-testid="navbar-logo-link"
            aria-label="Smarty home page"
          >
            <Icon
              name="smarty-logo"
              className={classes.logo}
              data-testid="navbar-logo"
              alt="Smarty logo - dashboard home"
            />
          </Link>
        ) : (
          <a
            href={marketingUrl}
            data-testid="navbar-logo-link"
            aria-label="Smarty home page"
          >
            <Icon
              name="smarty-logo"
              className={classes.logo}
              data-testid="navbar-logo"
              alt="Smarty logo - home page"
            />
          </a>
        )}
        <Icon
          name={isMenuOpen ? 'close' : 'burger-menu'}
          className={classes.menuIcon}
          onClick={toggleMenu}
          data-testid="toggle-menu-icon"
        />
        {!isMobile && (
          <DesktopMenu
            isAuthenticated={isAuthenticated}
            isAbandonedAccount={isAbandonedAccount}
            isActivated={isActivated}
            isNotInGroup={isNotInGroup}
            userHasUsage={userHasUsage}
            userHasAgreement={userHasAgreement}
            memberWithNickname={memberWithNickname}
            marketingUrl={marketingUrl}
            communityUrl={communityUrl}
            logoutUser={logoutUser}
          />
        )}
      </div>
      {isMobile && (
        <MobileMenu
          isOpen={isMenuOpen}
          isAuthenticated={isAuthenticated}
          isAbandonedAccount={isAbandonedAccount}
          isActivated={isActivated}
          isNotInGroup={isNotInGroup}
          userHasUsage={userHasUsage}
          userHasAgreement={userHasAgreement}
          memberWithNickname={memberWithNickname}
          closeMenu={closeMenu}
          marketingUrl={marketingUrl}
          communityUrl={communityUrl}
          logoutUser={logoutUser}
        />
      )}
    </nav>
  )
}
